import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { BasePageComponent } from '../../../core/classes/base-page';
import { UserService } from '../../../core/api/user.service';
import { RoleService } from '../../../core/api/role.service';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../../core/services/auth.service';
import { HelpersService } from '../../../core/services/helpers.service';
import { LoadingService } from '../../../core/services/loading.service';
import { debounceTime } from 'rxjs';
import { FileService } from '../../../core/api/file.service';

@Component({
  selector: 'app-employee',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
  ],
  templateUrl: './employee.component.html',
  styleUrl: './employee.component.scss',
})
export class EmployeeComponent
  extends BasePageComponent<any>
  implements OnInit
{
  searchFormControl = new FormControl();

  constructor(
    public override helpers: HelpersService,
    public override router: Router,
    public override activatedRoute: ActivatedRoute,
    public override dialog: MatDialog,
    public override loading: LoadingService,
    public override service: UserService,
    public override authService: AuthService,
    private fileService: FileService
  ) {
    super(
      helpers,
      router,
      activatedRoute,
      dialog,
      loading,
      service,
      authService
    );
    this.displayedColumns = [
      'no',
      'firstName',
      'employeeId',
      'team',
      'position',
      'created_at',
      'updated_at',
      'action',
    ];
    this.sortActive = 'updated_at';
    this.sortDirection = 'desc';
    this.subject = 'employeeId';
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.searchFormControl.valueChanges
      .pipe(debounceTime(300))
      .subscribe((val: any) => {
        this.q.search = val;
        this.getData();
      });
  }

  addEmployee() {
    this.router.navigate(['/dashboard/employee/action'], {
      queryParams: {
        m: 'add',
      },
    });
  }

  editEmployee(id: any) {
    this.router.navigate(['/dashboard/employee/action'], {
      queryParams: {
        m: 'edit',
        id,
      },
    });
  }

  override afterGetData(): void {
    const imagePromises = this.data.map((item: any) => this.getImageUrl(item));

    Promise.all(imagePromises).finally(() => {
      // Semua proses selesai
    });
  }

  private getImageUrl(item: any): Promise<void> {
    return new Promise((resolve) => {
      if (item.file) {
        this.loading.startLoading();
        this.fileService.download(item.file?.id).subscribe(
          (res) => {
            this.loading.endLoading();
            item['imageUrl'] = URL.createObjectURL(res);
            resolve();
          },
          (error) => {
            this.loading.endLoading();
            item['imageUrl'] = null;
            resolve();
          }
        );
      } else {
        item['imageUrl'] = null;
        resolve();
      }
    });
  }
}
